import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'dateTimeFormatFilter',
    standalone: false
})
export class DateTimeFormatPipe implements PipeTransform {
    transform(date, format: string) {
        if (date) {
            date = new Date(date.replace(/-/g, "/"));  // if orginal type was a string
            return new DatePipe('en-US').transform(date, format);
        }
    }
}

@Pipe({
  name: 'sortByName',
  standalone: false
})
export class SortByNamePipe implements PipeTransform {
  transform(array: any[]): any[] {
  if (!Array.isArray(array)) return array;

  return array.slice().sort((a, b) => {
      let aHasUnderscore = '';
      let bHasUnderscore = '';
      if(a?.id){
          aHasUnderscore = a.old_image_name.includes('_');
      }
      else{
          aHasUnderscore = a.new_image_name.includes('_');
      }
      if(b?.id){
          bHasUnderscore = b.old_image_name.includes('_');
      }
      else{
          bHasUnderscore = b.new_image_name.includes('_');
      }
      

      // If 'a' has no underscore and 'b' has an underscore, 'a' comes first
      if (!aHasUnderscore && bHasUnderscore) {
          return -1;
      }
      // If 'a' has an underscore and 'b' has no underscore, 'b' comes first
      if (aHasUnderscore && !bHasUnderscore) {
          return 1;
      }
      // If both have or both don't have underscores, sort alphabetically
      return a.image_name.localeCompare(b.image_name);
  })
  ;

  //   return array?.slice().sort((a, b) => a.image_name.localeCompare(b.image_name));
  }
}



@Pipe({
    name: 'searchBrands',
    standalone: false
})

export class SearchPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items || !searchText) return items;

    const lowerSearch = searchText.toLowerCase();

    return items.filter(item =>
      item.label?.toLowerCase().includes(lowerSearch)
    );
  }
}
